import { render, staticRenderFns } from "./TacticsFour.vue?vue&type=template&id=62e0f104&scoped=true"
var script = {}
import style0 from "./TacticsFour.vue?vue&type=style&index=0&id=62e0f104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e0f104",
  null
  
)

export default component.exports